import React from 'react';

import prettyBytes from 'pretty-bytes';

import RemoveIcon from '@atlaskit/icon/glyph/editor/remove';

import { ParsedFile } from '@qality/common-model';

import CsvIcon from './CsvIcon';
import { Clickable, FileDetails } from './File.styled';

const File = ({
  file,
  onRemoveFile,
}: {
  file: ParsedFile;
  onRemoveFile: () => void;
}) => {
  return (
    <>
      <CsvIcon />
      <FileDetails>{`${file.name} (${prettyBytes(file.size)})`}</FileDetails>
      <Clickable onClick={onRemoveFile}>
        <RemoveIcon />
      </Clickable>
    </>
  );
};

export default File;
